import { useCallback, useState } from 'react'
import { useIntl } from 'react-intl'

import { ButtonGroup, CardBody } from 'Components/_theme'
import { ShippingAddressForm } from 'Components/ShippingAddressForm/ShippingAddressForm'
import { ShippingAddressFormSchema } from 'Components/ShippingAddressForm/ShippingAddressForm.types'

import { E2E_REPLACE_BROKEN_DEVICE_BUTTON } from 'Constants/e2e'

import { REPLACE_BROKEN_DEVICE_MODAL_SHIPPING_FORM } from '../../ReplaceBrokenDeviceModal.constants'
import {
  ReplaceBrokenDeviceModalStepsEnum,
  ReplaceBrokenDeviceShippingFormProps,
} from '../../ReplaceBrokenDeviceModal.types'

export const ReplaceBrokenDeviceShippingForm = (
  props: ReplaceBrokenDeviceShippingFormProps,
) => {
  const { rental, shippingFormData, onCancel, onSetCurrentStep } = props
  const [isSubmitting, setIsSubmitting] = useState(false)
  const intl = useIntl()

  const handleCancel = useCallback(() => {
    onCancel()
  }, [onCancel])

  const handleSubmit = useCallback(
    (data: ShippingAddressFormSchema) => {
      onSetCurrentStep(ReplaceBrokenDeviceModalStepsEnum.SUMMARY, data)
    },
    [onSetCurrentStep],
  )

  return (
    <CardBody>
      <ShippingAddressForm
        defaultValues={shippingFormData}
        formId={REPLACE_BROKEN_DEVICE_MODAL_SHIPPING_FORM}
        onSetIsSubmitting={setIsSubmitting}
        onSubmit={handleSubmit}
        rental={rental}
      />

      <ButtonGroup
        leftButton={{
          onClick: handleCancel,
          text: intl.formatMessage({ id: 'Cancel' }),
        }}
        rightButton={{
          'data-e2e': E2E_REPLACE_BROKEN_DEVICE_BUTTON,
          disabled: isSubmitting,
          form: REPLACE_BROKEN_DEVICE_MODAL_SHIPPING_FORM,
          text: intl.formatMessage({ id: 'Next' }),
          type: 'submit',
        }}
      />
    </CardBody>
  )
}
